<template>
  <div class="container">
    <h5>活动列表</h5>
    <section class="cont">
      <div class="item boxShadow" v-for="item in list">
        <div class='content'>
          <h6>{{item.title}}</h6>
          <p><img :src="item.cover" alt=""></p>
          <div class="btn btn-primary" @click="$router.push(`/activity?id=${item.id}`)">详情</div>
        </div>
      </div>
      <page-component :total="totalPage" :current="currentPage" @getPage="catchPage"></page-component>
    </section>
    <div class="user_center" @click="$router.push('/account')">
      个人中心
    </div>
  </div>
</template>

<script>
import pageComponent from '../components/pagination.vue'
export default {
  inject: ['ajax'],
  data() {
    return {
      list: [],
      totalPage: 0,
      currentPage: 1
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.currentPage = this.$route.query.page || 1
    this.ajax('/api/act/index?page=' + this.currentPage, 'get', '', res => {
      this.list = res.data.data
      this.totalPage = res.data.count
    })
  },
  watch: {

  },
  methods: {
    linkTo(id, title, count) {
      if (count != 0) {
        this.$router.push({
          path: '/signup',
          query: {
            id: id,
            title: title
          }
        })
      }

    },
    catchPage(page) {
      console.log(page)
      this.currentPage = page
      if (page != this.$route.query.page) {
        window.location.href = `/activityList?page=${this.currentPage}`
      }
    }
  },
  components: {
    pageComponent
  },
};
</script>

<style scoped>
.container {
  background: #fff;
  padding: 50px;
}

.container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.cont {
  padding: 1em 0;
  display: flex;
  flex-wrap: wrap;
}

.cont .item {
  width: 32%;
  display: inherit;
  justify-content: space-between;
  margin-bottom: 1em;
  min-height: 13em;
  cursor: default;
  margin-right: 1em;
}
.cont .item:nth-child(3n) {
  margin-right: 0em;
}
.cont .item:hover {
  box-shadow: 0 5px 10px #cde6ff;
}

.cont .item .images {
  overflow: hidden;
}

.cont .item .images > img {
  width: 284px;
  height: 200px;
  object-fit: cover;
}

.cont .item .content {
  padding: 1.5em 1.5em 3.5em;
  width: 100%;
  position: relative;
}

.cont .item .content h6 {
  font-size: 1em;
  color: #333;
  font-weight: bold;
  margin-bottom: 0.8em;
}

.cont .item .content p {
  font-size: 0.9em;
  color: #666666;
}

.btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 1em;
}

@media only screen and (max-width: 750px) {
  .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }

  .cont .item {
    width: 100%;
  }

  .container {
    padding: 0.2rem;
  }
}
</style>